var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "comment-header" }, [
        _c("div", { staticClass: "left" }, [
          _vm._v("\n            我来说两句\n        "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _vm.showShine
            ? _c("a", {
                staticClass: "shine",
                attrs: {
                  href: "//www.sohu.com/collection/1065",
                  target: "_blank",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "num-red" }, [
            _vm._v(_vm._s(_vm.participationSum)),
          ]),
          _vm._v("人参与，\n            "),
          _c("span", { staticClass: "num-red" }, [
            _vm._v(_vm._s(_vm.outerCmtSum)),
          ]),
          _vm._v("条评论\n        "),
        ]),
      ]),
      _vm._v(" "),
      _c("Publish", { attrs: { showUser: true, data: _vm.meCommentData } }),
      _vm._v(" "),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-comment-convention" }, [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "http://zt.pinglun.sohu.com/s2014/sljyhgy/index.shtml",
          },
        },
        [_vm._v("\n            搜狐“我来说两句” 用户公约\n        ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }